//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * The automatic GLSL constant for {@link Pass#VOXELS}\n\
 *\n\
 * @name czm_passVoxels\n\
 * @glslConstant\n\
 *\n\
 * @see czm_pass\n\
 */\n\
const float czm_passVoxels = 10.0;\n\
";
